<template>
  <img v-if="getHotOrNew" class="hot-or-new" :src="getHotOrNew" />
</template>

<script type="">
import HotIcon from '@/assets/images/fill-hot@3x.png'
import NewIcon from '@/assets/images/fill-new@3x.png'

export default {
  name: 'HotOrNew',
  props: {
    menu: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  computed: {
    getHotOrNew() {
      const { is_hot, isHot, is_new, isNew } = this.menu
      if (is_hot || isHot) {
        return this.HotIcon
      }
      if (is_new || isNew) {
        return this.NewIcon
      }

      return ''
    },
  },
  data() {
    return {
      HotIcon,
      NewIcon,
    }
  }
}
</script>
<style>
.hot-or-new {
  width: 24px;
}
</style>



// WEBPACK FOOTER //
// src/view/Home/menu/HotOrNew.vue